import RESTClient from 'web-app/api/clients/rest-client-famly-app';

import Employee from './model';

export const fetchEmployee = employeeId => {
    return RESTClient.getAuthenticatedObservable(`v2/employees/${employeeId}`);
};

export const fetchAllEmployees = institutionId => {
    return RESTClient.getAuthenticatedObservable('v2/employees', {institutionId}).map(employees =>
        employees.map(Employee.fromAPI),
    );
};

export const createEmployee = (institutionId, name, email, groupId, phone, status) => {
    return RESTClient.postAuthenticatedObservable('v2/employees', {
        institutionId,
        name,
        email,
        groupId,
        phone,
        status,
    }).map(employee => Employee.fromAPI(employee));
};

export const updateGroup = (employeeId, groupId) => {
    return RESTClient.postAuthenticatedObservable(`v2/employees/${employeeId}`, {
        groupId,
    }).map(employee => Employee.fromAPI(employee));
};

export const updateKeyChildren = (employeeId, childMapping) => {
    return RESTClient.putAuthenticatedObservable(`v2/employees/${employeeId}/key-worker`, {childMapping});
};

export const changeGroup = (employeeId, newGroupId) => {
    return RESTClient.postAuthenticatedObservable(`v2/employees/${employeeId}`, {
        groupId: newGroupId,
    });
};

export const assignTag = (employeeId, tagId) => {
    return RESTClient.postAuthenticatedObservable(`v2/tags/${tagId}/assign`, {
        employeeId,
    });
};

export const removeTag = (employeeId, tagId) => {
    return RESTClient.postAuthenticatedObservable(`v2/tags/${tagId}/unassign `, {
        employeeId,
    });
};

export const updateEmployee = (employeeId, formData) => {
    return RESTClient.postAuthenticatedObservable(`v2/employees/${employeeId}`, {
        ...formData,
    });
};
